import axios from 'axios';

const apiTrack = axios.create({
  baseURL: process.env.REACT_APP_URL_ANALYTICS,
});

export default apiTrack;
